import { FC } from 'react';
import { TableProps, Column } from 'react-table';
import defaultProps from './defaultProps';

import { StyledTable } from './StyledTable';

export const Table: FC<Partial<TableProps>> = props => <StyledTable {...props} />;

// eslint-disable-next-line prettier/prettier
export type { Column };

Table.defaultProps = defaultProps;
